import React from 'react';
import IconError from '../../images/icon-error.svg';
import IconSuccess from '../../images/icon-success.svg';
const Notification = ({ type, children }) => {
    return (React.createElement("div", { className: 'notification' },
        React.createElement("div", { className: 'icon' },
            type === 'success' && React.createElement(IconSuccess, null),
            type === 'error' && React.createElement(IconError, null)),
        React.createElement("p", null, children)));
};
export default Notification;
